import { Box } from '@mui/material';

export const LoginLogo = ({ src }) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      marginBottom: { xs: '20px', md: '40px' },
    }}
  >
    <Box
      component="img"
      src={src}
      alt="Logo"
      sx={{
        maxHeight: { xs: '50px', md: '80px' },
        width: 'auto',
        maxWidth: '100%',
        objectFit: 'contain',
      }}
    />
  </Box>
);
